import { User } from '../models/interfaces/user.interface';

export const buildUpdateUser = (currentUser: User, newestUser: User): User => {
  return {
    id: currentUser.id,
    firstName: newestUser.firstName,
    lastName: newestUser.lastName,
    password: newestUser.password,
    email: newestUser.email,
    dtCreated: currentUser.dtCreated,
    phone: newestUser.phone,
    photo: currentUser.photo,
    active: currentUser.active,
    idsProfiles: newestUser.idsProfiles,
    userNotifications: currentUser.userNotifications,
    idsSchool: currentUser.idsSchool,
  };
};
